import { Injectable,Inject, OnInit } from '@angular/core';
import { DOCUMENT } from '@angular/common';
declare var dataLayer;
declare var gtag: Function;
export interface GAGTMParams {
  pagetype: string;
  label: string;
}
@Injectable({
  providedIn: 'root'
})
export class DataLayerService{
  private webengage:any;
  constructor( @Inject(DOCUMENT) private document: Document) { 
  }

  public onNavClick(params: GAGTMParams) {
    dataLayer.push({
      'event': 'navigation_tab_click',
      'eventCategory': params.pagetype,
      'eventAction': 'Navigation_Tab_Click',
      'eventLabel': params.label
    });
  }
  public onContinueClick(params: GAGTMParams) {
    dataLayer.push({
      'event': 'continue_click',
      'eventCategory': params.pagetype,
      'eventAction': 'continue_click',
      'eventLabel': params.label
    });
  }
  public onKYCProceedClick(params: GAGTMParams) {
    dataLayer.push({
      'event': 'non_kyc_proceed_click',
      'eventCategory': params.pagetype,
      'eventAction': 'non_kyc_proceed_click',
      'eventLabel': params.label
    });
  }
  public onOTPSubmitClick(params: GAGTMParams) {
    dataLayer.push({
      'event': 'otp_submit_click',
      'eventCategory': params.pagetype,
      'eventAction': 'otp_submit_click',
      'eventLabel': params.label
    });
  }
  public onResendOTPClick(params: GAGTMParams) {
    dataLayer.push({
      'event': 'resend_otp_click',
      'eventCategory': params.pagetype,
      'eventAction': 'resend_otp_click',
      'eventLabel': params.label
    });
  }
  public onTnCClick(params: GAGTMParams) {
    dataLayer.push({
      'event': 'terms_and_conditions_click',
      'eventCategory': params.pagetype,
      'eventAction': 'terms_and_conditions_click',
      'eventLabel': params.label
    });
  }
  public onApplyNowClick(params: GAGTMParams) {
    dataLayer.push({
      'event': 'apply_now_click',
      'eventCategory': params.pagetype,
      'eventAction': 'apply_now_click',
      'eventLabel': params.label
    });
  }

  public onLogoClick(params: GAGTMParams) {
    dataLayer.push({
      'event': 'logo_click',
      'eventCategory': params.pagetype,
      'eventAction': 'logo_click',
      'eventLabel': params.label
    });
  }
  public onFormSubmitClick(params: GAGTMParams) {
    dataLayer.push({
      'event': 'form_submit_click',
      'eventCategory': params.pagetype,
      'eventAction': 'form_submit_click',
      'eventLabel': params.label
    });
  }
  public onFormClickHereClick(params: GAGTMParams) {
    dataLayer.push({
      'event': 'form_click_here',
      'eventCategory': params.pagetype,
      'eventAction': 'form_click_here',
      'eventLabel': params.label
    });
  }
  public onFormOkClick(params: GAGTMParams) {
    dataLayer.push({
      'event': 'form_ok_click',
      'eventCategory': params.pagetype,
      'eventAction': 'form_ok_click',
      'eventLabel': params.label
    });
  }
  public onPopupModifyClick(params: GAGTMParams) {
    dataLayer.push({
      'event': 'popup_modify_click',
      'eventCategory': params.pagetype,
      'eventAction': 'popup_modify_click',
      'eventLabel': params.label
    });
  }
  public onPopupContinueClick(params: GAGTMParams) {
    dataLayer.push({
      'event': 'popup_continue_click',
      'eventCategory': params.pagetype,
      'eventAction': 'popup_continue_click',
      'eventLabel': params.label
    });
  }

  public onSendOTP(params: GAGTMParams) {
    dataLayer.push({
      'event': 'send_otp_click',
      'eventCategory': params.pagetype,
      'eventAction': 'send_otp_click',
      'eventLabel': params.label
    });
  }
  
  public pushGAData(arg){
    dataLayer.push(arg)
  }

  public initRegisterGA() {
    return new Promise((resolve, reject) => {
      if (!window['gtag']) {
        window['gtag'] = function gtag() {
          dataLayer.push(arguments);
        }
        let script = document.createElement("script");
        script.src = "https://www.googletagmanager.com/gtag/js?id=UA-45018221-12";
        script.onload = () => {
          if (/dev|stage|localhost/g.test(window.location.origin)) {
            console.log("loaded")
          }

          gtag('js', new Date());
          gtag('config', 'UA-45018221-12');
          resolve(true);
        }
        script.onerror = () => {

          resolve(false);
        }
        document.head.appendChild(script);

      } else {
        resolve(true);
      }
    });

  }
  public gtagReportConversion(url) {
    var callback = function () {
      if (typeof (url) != 'undefined') {
        setTimeout(() => {
         // window.location = url;
        }, 1000)

      }
    };
    gtag('event', 'conversion', {
      'send_to': 'AW-728080364/YWbICNy71cQBEOy_ltsC',
      'event_callback': callback
    });
  }
  public setGTagForRegisterPage() {
    console.log("working on load")
    gtag('event', 'conversion', { 'send_to': 'AW-728080364/O_kUCJvaicMBEOy_ltsC' });
  }
  public trackEvent(eventName: any, eventData?:any): void {
    try{
    this.webengage = this.document.defaultView.webengage;
    this.webengage.track(eventName,eventData);
    }
    catch(e){
      console.log('webengage ERROR ',e)
    }
  }
}
